import { __decorate } from "tslib";
import { ApiResource } from '../../lib/api-decorators';
import { Api } from '../../lib/api.factory';
let SourceResource = class SourceResource extends Api {
    create(source) {
        return this.post('/', source);
    }
    getSource(id) {
        return this.get(`/${id}`);
    }
    getCategoriesWithSources(project) {
        return this.get('/category-list', { project });
    }
    getList(project) {
        return this.get('/list', { project });
    }
    update(source) {
        return this.put(`/${source.id}`, source);
    }
    deleteSource(id) {
        return this.delete(`/${id}`);
    }
};
SourceResource = __decorate([
    ApiResource('/source')
], SourceResource);
export { SourceResource };
